const baseStyle = (props: Record<string, any>) => {
  return {
    justifyContent: 'flex-start',
    flexDirection: 'row',
    borderWidth: 1,
    borderRadius: 'xs',
    opacity: 1,
    p: 0,

    _light: {
      bgColor: 'white',
      borderColor: 'gray.600',
      _text: {
        color: 'darkText',
      },
      _icon: {
        color: `white`,
      },
      _checked: {
        borderColor: `blue.500`,
        bgColor: `blue.500`,
        _invalid: {
          bgColor: 'error.500',
        },
        _hover: {
          borderColor: 'blue.500',
          bgColor: 'blue.500',
          _disabled: {
            borderColor: 'gray.600',
            bgColor: 'gray.50',
          },
        },
      },
      _hover: {
        borderColor: 'gray.600',
        bgColor: 'blue.50',
        _disabled: {
          borderColor: 'gray.600',
        },
        _invalid: {
          borderColor: 'error.500',
          bgColor: 'red.50',
        },
      },
      _pressed: {
        borderColor: 'blue.600',
        _invalid: {
          borderColor: 'error.600',
        },
      },
      _invalid: {
        borderColor: 'error.500',
      },
    },

    _dark: {
      bgColor: 'white',
      borderColor: 'gray.600',
      _text: {
        color: 'darkText',
      },
      _icon: {
        color: `white`,
      },
      _checked: {
        borderColor: `blue.500`,
        bgColor: `blue.500`,
        _invalid: {
          bgColor: 'error.500',
        },
        _hover: {
          borderColor: 'blue.500',
          bgColor: 'blue.500',
          _disabled: {
            borderColor: 'gray.600',
            bgColor: 'gray.50',
          },
        },
      },
      _hover: {
        borderColor: 'gray.600',
        bgColor: 'blue.50',
        _disabled: {
          borderColor: 'gray.600',
        },
        _invalid: {
          borderColor: 'error.500',
          bgColor: 'red.50',
        },
      },
      _pressed: {
        borderColor: 'blue.600',
        _invalid: {
          borderColor: 'error.600',
        },
      },
      _invalid: {
        borderColor: 'error.500',
      },
    },

    _stack: {
      direction: 'row',
      alignItems: 'center',
      space: 0,
      _web: {
        cursor: props.isDisabled ? 'not-allowed' : 'pointer',
      },
    },

    _text: {
      ml: 2,
      flexShrink: 1,
      _web: {
        style: {
          userSelect: 'none',
        },
      },
    },

    _focusVisible: {
      _borderColor: 'blue.500',
      _web: {
        style: {
          outlineWidth: '0px',
          outlineColor: 'transparent',
          outlineStyle: 'solid',
        },
      },
    },

    _disabled: {
      bgColor: 'gray.50',
      borderColor: 'gray.600',
      opacity: 1.0,
      _icon: {
        color: 'gray.500',
      },
      _web: {
        cursor: 'not-allowed',
      },
      _text: {
        color: 'gray.500',
      },
    },
  };
};

const sizes = {
  lg: { _icon: { size: 4 }, _text: { fontSize: 'md', lineHeight: 'md' } },
  md: { _icon: { size: 4 }, _text: { fontSize: 'md', lineHeight: 'md' } },
  sm: { _icon: { size: 4 }, _text: { fontSize: 'md', lineHeight: 'md' } },
};

const variants = {
  default: {},
  bordered: {
    _stack: {
      bgColor: 'white',
      borderColor: 'gray.200',
      borderWidth: 1,
      borderRadius: 'sm',
      p: 3,
    },
  },
};

const defaultProps = {
  defaultIsChecked: false,
  size: 'sm',
  colorScheme: 'primary',
  variant: 'default',
};

export default {
  baseStyle,
  sizes,
  variants,
  defaultProps,
};
